module.exports = __webpack_public_path__ + "img/fangwei-hover.788f9e3c.png";